export default "__VITE_ASSET__3KerIKym__"